import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isMultiple", "isReadonly", "allowClear", "placeholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Select } from 'antd';
import { getClientStore } from 'core/modules/clients/client.store';
import { useTranslation } from 'react-i18next';
import { sanitizeAll } from '../../utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";

/** Renders a select to select clients. */
export var ClientSelect = function ClientSelect(_ref) {
  var isMultiple = _ref.isMultiple,
      isReadonly = _ref.isReadonly,
      allowClear = _ref.allowClear,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getClientStore = getClientStore(),
      clients = _getClientStore.clients;

  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
    mode: isMultiple ? 'multiple' : undefined,
    allowClear: allowClear,
    bordered: !isReadonly,
    disabled: isReadonly,
    showSearch: true,
    filterOption: function filterOption(input, option) {
      return sanitizeAll(option.title).includes(sanitizeAll(input));
    },
    placeholder: isReadonly ? undefined : placeholder !== null && placeholder !== void 0 ? placeholder : t('form.task.client.placeholder'),
    children: clients.map(function (client) {
      return /*#__PURE__*/_jsx(Select.Option, {
        value: client.id,
        title: "".concat(client.name, " ").concat(client.taxName, " ").concat(client.taxNumber),
        children: client.name
      }, client.id);
    })
  }));
};